var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"id":"alert-delete","aria-label":"alert-delete","color":"error"},on:{"click":_vm.deleteAlert}},[_c('v-icon',[_vm._v("delete")]),_vm._v("\n    "+_vm._s(_vm.$t('admin.alerts.new.delete_alert'))+"\n  ")],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0618f41e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/alert/AlertDeleteButton.vue
// module id = null
// module chunks = 